const Modules = [
	{
		moduleName: 'common',
		callScript: async () => {
			const { Common } = await import('./flexible-contents/common');
			Common();
		},
	},

	{
		moduleName: 'test',
		callScript: async () => {
			const { Test } = await import('./flexible-contents/test');
			Test();
		},
	},
    {
        moduleName: 'partners',
        callScript: async () => {
            try {
                const { partnersSlider } = await import( './flexible-contents/partners-slider' );
                partnersSlider();
            } catch (error) {
                console.error(error);
            }
        },
    },
];

export default Modules;
